<template>
    <v-container fluid>
    
        <v-card flat>
            <v-toolbar>
                <v-icon></v-icon>
                <v-toolbar-title class="font-weight-light"> 
                    <v-row>
                        <v-col >
                            <div>&nbsp;Listados de Caja </div>
                        </v-col>
                    </v-row>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click.stop="hide(false)"><v-icon>close</v-icon></v-btn>                    
            </v-toolbar>

            <v-card-text>
                <v-container fluid>                    
                    <v-row>
                        <v-col cols="2">
                            Caja
                        </v-col>
                        <v-col>
                            {{caja.descripcion}}
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="2">
                            Fecha
                        </v-col>
                        <v-col>
                            {{this.$moment(caja.abiertaEl).format('DD-MM-YYYY')}}
                        </v-col>
                    </v-row>
                    <v-divider></v-divider>

                    
                    <v-row dense>
                        <v-col cols="7">
                            <v-switch v-model="detalleMovimientos" label="Detalle de Movimientos" ></v-switch>
                        </v-col>
                        <v-col>
                            <v-switch v-model="mostrarAnulados" label="Con Anulados" ></v-switch>
                        </v-col>
                    </v-row>
                    
                    <v-row dense>
                        <v-col>
                            <v-switch v-model="resumenCaja" label="Resumen de Caja" ></v-switch>
                        </v-col>
                    </v-row>

                    <v-row dense> 
                        <v-col>                       
                            <v-switch v-model="detalleDiferencias" label="Detalle de Diferencias" ></v-switch>
                        </v-col>
                    </v-row>

                </v-container>
            </v-card-text>

            <v-divider></v-divider>  
            <v-card-actions>
                <v-btn color="blue darken-1" text @click.stop="hide(false)">Cerrar</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click.stop="generar()" >Generar</v-btn>
            </v-card-actions>
        </v-card>
        
        <template v-if="$store.state.debugModeOn">
            Debug Info: <p></p>
            
            Model: {{gestion}}  <p></p>                            
        </template>
    </v-container>
</template>


<script>

import Vue from 'vue'
import { http } from '@/axios'

import {
  mapState,
  mapGetters,
  mapMutations,
  mapActions
} from 'vuex'

export default {
    data: () => ({        
        saving: false,
        loadingCajas: false,
        detalleMovimientos: true,
        mostrarAnulados: false,
        resumenCaja: false,
        detalleDiferencias: false,
        }
    ),
    props:{
        caja: { type: Object, default: {} },        
        accionCompleta:{ type: Function },
        isSubTask: { type: Boolean, default: false },
        visible: { type: Boolean, default: false },
    },
    async created(){  
        
    },
    computed: {
        ...mapGetters(['getActionFromLink','user']),
        show: {
            get () {
                return this.visible
            },
            set (value) {
                if (!value) {
                    this.$emit('close')
                }
            }
        },
    },
    watch:{
        visible: function(){
            if(this.visible){
            }
        },        
    },
    methods:{
    ...mapMutations(["setActiveTask", "setActiveSubTask", "hideActiveTask", "hideActiveSubTask", 
                        "alertClear", "alertSuccess", "alertWarning", "alertError","setReporteActivo"]),
    async generar(){
        
        if(this.detalleMovimientos){
            let params = [];
                params.push({
                Version: 'beta',
                CajaId: this.caja.id,
                MonedaId: 1, // pesos
                FechaDesde: this.caja.abiertaEl,
                FechaHasta: this.caja.abiertaEl,
                IncluirAnulados: this.mostrarAnulados,
                SoloDiferencias: false,
                SoloConceptoId: 0,
                Caja: this.caja.descripcion,
            } );

            this.setReporteActivo({reporte: 'Detalle Movimientos de Caja.trdp', params: params})
            window.open('/report-viewer');
        }

        if(this.detalleDiferencias){
            let params = [];
                params.push({
                Version: 'beta',
                CajaId: this.caja.id,
                MonedaId: 1, // pesos
                FechaDesde: this.caja.abiertaEl,
                FechaHasta: this.caja.abiertaEl,
                IncluirAnulados: this.mostrarAnulados,
                SoloDiferencias: true,
                SoloConceptoId: 0,
                Caja: this.caja.descripcion,
            } );

            this.setReporteActivo({reporte: 'Detalle Movimientos de Caja.trdp', params: params})
            window.open('/report-viewer');
        }

        if(this.resumenCaja){
            let params = [];
                params.push({
                Version: 'beta',
                CajaId: this.caja.id,
                MonedaId: 1, // pesos
                FechaDesde: this.caja.abiertaEl,
                FechaHasta: this.caja.abiertaEl,
                Caja: this.caja.descripcion,
                EmpresaId: 0,
                Sucursales: '0',
                
            } );

            this.setReporteActivo({reporte: 'Movimientos de Caja Agrupado por Cuenta.trdp', params: params})
            window.open('/report-viewer');
        }
    },   
    hide(cerrarRelacionados){
        //esto lo hago para que no se buguee cuando lo abro como subtask o task
        if(this.isSubTask)
            this.hideActiveSubTask();
        else
            this.hideActiveTask(cerrarRelacionados);
    }    
  }
}
</script>
